import { useState } from 'react'
import { getPcekZone, useAuthDataStore } from '@entities/user'
import { ewalletApi } from '@root/api/api'
import { TransactionResponse } from '@root/api/ump-ewallet'

interface PaymentDoReqProps {
  serviceId?: string
  amount?: number
  currency?: number
  bindingId?: string
  pan?: string
  mdOrder?: string
  expiry?: string
  cardholderName?: string
  cvc?: string
  serviceParams?: string
  comment?: string
  masterpassOperationId?: string
  is3dsRequired?: boolean
  options?: any
  onSuccess?: (data: TransactionResponse) => void
  onError?: (error) => void
}

export const usePaymentDo = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { profile } = useAuthDataStore()
  const userId = profile?.userId

  const paymentDo = async ({
    currency,
    mdOrder,
    amount,
    serviceId,
    bindingId,
    pan,
    expiry,
    cardholderName,
    cvc,
    serviceParams,
    comment,
    masterpassOperationId,
    is3dsRequired,
    options,
    onSuccess,
    onError,
  }: PaymentDoReqProps) => {
    setIsLoading(true)

    try {
      const { data } = await ewalletApi.paymentDo(
        getPcekZone(),
        userId,
        mdOrder,
        bindingId,
        pan,
        expiry,
        cardholderName,
        cvc,
        serviceId,
        serviceParams,
        amount,
        currency,
        comment,
        masterpassOperationId,
        is3dsRequired,
        options
      )

      if (!data.errorMessage) {
        if (onSuccess) onSuccess(data)
      } else if (onError) {
        onError(new Error(data.errorMessage))
      }
    } catch (error) {
      if (onError && error?.code !== 'ERR_CANCELED') onError(error)
    } finally {
      setIsLoading(false)
    }
  }

  return { paymentDo, isLoading }
}
